import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import helperSpinner from "../../../../../helpers/spinner";
import helperNumbers from "../../../../../helpers/numbers";
import helpersTime from "../../../../../helpers/time";
import httpService from "../../../../../services/httpServices/httpServices";
import StatusAskCheckout from "../StatusAskCheckout";

export default function ManageMarketerViewAskCheckout() {
  const [AskCheckout, setAskCheckout] = useState();
  const [receiptPaymentImage, setReceiptPaymentImage] = useState();
  const [state, newState] = useState(StatusAskCheckout.statusAskCheckout.PAID);
  const params = useParams();
  const AskCheckoutID = params.askCheckoutID;
  const history = useHistory();
  useEffect(() => {
    getAskCheckout();
  }, []);

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAskCheckout = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let AskCheckout = await sendRequestGetAskCheckout(AskCheckoutID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!AskCheckout) {
      return;
    }

    setAskCheckout(AskCheckout);
  };

  const sendRequestGetAskCheckout = async (AskCheckoutID) => {
    const headersRequest = getHeaderRequest();
    let AskCheckout;
    try {
      AskCheckout = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/marketer/manage/ask-checkout/" +
          AskCheckoutID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return AskCheckout.data.data;
  };

  const sendForm = async () => {
    const formData = getFormData();

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultEditAskCheckout = await sendRequestSetNewStateAskCheckout(
      AskCheckoutID,
      formData
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultEditAskCheckout) {
      return;
    }

    history.push("/finance/manage/marketer/ask-checkout");
  };

  const getFormData = () => {
    const formData = new FormData();
    formData.append("state", state);
    if (state == StatusAskCheckout.statusAskCheckout.PAID) {
      formData.append("image", receiptPaymentImage);
    } else if (state == StatusAskCheckout.statusAskCheckout.REJECT) {
      formData.append(
        "message",
        document.querySelector("#reason-reject").value
      );
    }
    return formData;
  };

  const sendRequestSetNewStateAskCheckout = async (AskCheckoutID, formData) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/marketer/manage/ask-checkout/" +
          AskCheckoutID,
        formData,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateAskCheckout = () => {
    let classBadgeStatePage;
    switch (AskCheckout.mac_status) {
      case StatusAskCheckout.statusAskCheckout.PENDING:
        classBadgeStatePage = "badge-warning";
        break;
      case StatusAskCheckout.statusAskCheckout.PAID:
        classBadgeStatePage = "badge-info";
        break;
      case StatusAskCheckout.statusAskCheckout.REJECT:
        classBadgeStatePage = "badge-danger";
        break;
    }

    return (
      <div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td
                  colSpan={2}
                  className="text-center"
                  style={{ borderRadius: "25px 25px 0 0" }}
                >
                  اطلاعات وارد شده برای درخواست انتقال وجه
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>شماره درخواست</td>
                <td> {helperNumbers.toPersianNum(AskCheckout.mac_id)}</td>
              </tr>
              <tr>
                <td>مبلغ (تومان)</td>
                <td>
                  <label className="letter-spacing-finance-number pl-2">
                    {helperNumbers.toPersianNum(
                      helperNumbers.toFormatFinanceNumber(AskCheckout.mac_price)
                    )}
                  </label>
                  <label>تومان</label>
                </td>
              </tr>
              <tr>
                <td>نام بانک </td>
                <td>{AskCheckout.mac_bank_name}</td>
              </tr>
              <tr>
                <td>نام مالک حساب</td>
                <td>{AskCheckout.mac_owner_account_name}</td>
              </tr>
              <tr>
                <td>شماره حساب بانکی</td>
                <td>{AskCheckout.mac_account_number}</td>
              </tr>
              <tr>
                <td>شماره کارت بانکی </td>
                <td>{AskCheckout.mac_account_cart_number}</td>
              </tr>
              <tr>
                <td>شماره شبا </td>
                <td>{AskCheckout.mac_account_shaba_number}</td>
              </tr>
              <tr>
                <td>وضعیت</td>
                <td>
                  <span className={`badge ${classBadgeStatePage}`}>
                    {
                      StatusAskCheckout.getStatusAskCheckoutString()[
                        AskCheckout.mac_status
                      ]
                    }
                  </span>
                </td>
              </tr>

              {StatusAskCheckout.statusAskCheckout.REJECT ==
                AskCheckout.mac_status && (
                <tr>
                  <td>دلیل رد شدن</td>
                  <td> {AskCheckout.mac_message}</td>
                </tr>
              )}
              {StatusAskCheckout.statusAskCheckout.PAID ==
                AskCheckout.mac_status && (
                <>
                  <tr>
                    <td>عکس رسید پرداخت</td>
                    <td>
                      <a
                        target="_blank"
                        href={AskCheckout.mac_receipt_payment_image}
                      >
                        <img
                          className="img-fluid"
                          src={AskCheckout.mac_receipt_payment_image}
                        />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>تاریخ پرداخت</td>
                    <td>
                      {helperNumbers.toPersianNum(
                        AskCheckout.mac_paid_at.split(" ")[1] +
                          " " +
                          helpersTime.convertGregorianToJalali(
                            AskCheckout.mac_paid_at.split(" ")[0]
                          )
                      )}
                    </td>
                  </tr>
                </>
              )}

              <tr>
                <td>تاریخ درج</td>
                <td>
                  {helperNumbers.toPersianNum(
                    AskCheckout.mac_created_at.split(" ")[1] +
                      " " +
                      helpersTime.convertGregorianToJalali(
                        AskCheckout.mac_created_at.split(" ")[0]
                      )
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <hr />
        <h3>اعمال وضعیت جدید درخواست تسویه حساب نمایش دهنده</h3>
        <div className="alert alert-warning">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <p className="text-justify">
            درصورت موافقت و پرداخت مبلغ به حساب بانکی کاربر نمایش دهنده حتما
            طریق
            <Link
              className="d-inline-block px-2"
              target="_blank"
              to="/finance/manage/all-transaction"
            >
              تراکنش دستی
            </Link>
            موجود کاربر را به اندازه مبلغ پرداخت شده کسر کنید
          </p>
        </div>
        <div className="pt-2">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              sendForm();
            }}
          >
            <div className="form-group w-50">
              <label>وضعیت جدید</label>
              <select
                className="form-control"
                onChange={(e) => {
                  newState(e.target.value);
                }}
              >
                <option value={StatusAskCheckout.statusAskCheckout.PAID}>
                  {
                    StatusAskCheckout.getStatusAskCheckoutString()[
                      StatusAskCheckout.statusAskCheckout.PAID
                    ]
                  }
                </option>
                <option value={StatusAskCheckout.statusAskCheckout.REJECT}>
                  {
                    StatusAskCheckout.getStatusAskCheckoutString()[
                      StatusAskCheckout.statusAskCheckout.REJECT
                    ]
                  }
                </option>
              </select>
            </div>
            {state == StatusAskCheckout.statusAskCheckout.PAID && (
              <div className="form-group">
                <label>عکس رسید پرداخت</label>
                <input
                  required
                  className="form-control"
                  id="receipt-payment-image"
                  type="file"
                  accept="image/png, image/gif, image/jpeg, image/webp"
                  onChange={(e) => {
                    setReceiptPaymentImage(e.target.files[0]);
                  }}
                />
              </div>
            )}
            {state == StatusAskCheckout.statusAskCheckout.REJECT && (
              <div className="form-group">
                <label>دلیل رد شدن</label>
                <textarea
                  className="form-control"
                  id="reason-reject"
                  rows="10"
                  required
                ></textarea>
              </div>
            )}
            <div>
              <button className="btn btn-success">اعمال وضعیت جدید</button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="مشاهده وضعیت درخواست انتقال موجودی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="btn btn-primary"
                  to="/finance/manage/marketer/ask-checkout"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div>{AskCheckout && generateAskCheckout()}</div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
